import React, { useMemo } from "react";
import { useUserStore } from "../hooks/useUserStore";
import Avatar from "react-avatar";
import { getUserInitials } from "../utils/userUtils";

const AvatarComponent = () => {
  const { userData } = useUserStore();

  const initials = useMemo(() => getUserInitials(userData), [userData]);
  return (
    <Avatar
      size={"34"}
      round
      style={{
        verticalAlign: "middle",
      }}
      src={userData?.imageThumbnailUrl}
      initials={initials}
      name={`${userData?.firstName} ${userData?.lastName}`}
    />
  );
};

export default AvatarComponent;
